export const VideosActive = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM10.416 7.37598C10.1859 7.2226 9.89031 7.20849 9.64648 7.33887C9.43311 7.45306 9.28932 7.66175 9.25684 7.89746L9.25 8V16C9.25 16.2766 9.40262 16.5306 9.64648 16.6611C9.89031 16.7915 10.1859 16.7774 10.416 16.624L16.416 12.624C16.6247 12.4849 16.75 12.2508 16.75 12C16.75 11.7492 16.6247 11.5151 16.416 11.376L10.416 7.37598Z"
        fill="currentColor"
      />
    </svg>
  );
};
